export default {
    topics: [
        {
            title: ' Generate ',
            href: 'sm-specFile-Generate.html',
            attributes: { 'data-id': 'sm-specFile-Generate' },
            menu: { hasChildren: false },
            tocID: 'sm-specFile-Generate-d66e1648',
            topics: [],
        },
        {
            title: ' GenerateDoc ',
            href: 'sm-specFile-GenerateDoc.html',
            attributes: { 'data-id': 'sm-specFile-GenerateDoc' },
            menu: { hasChildren: false },
            tocID: 'sm-specFile-GenerateDoc-d66e1656',
            topics: [],
        },
    ],
};

